import React from 'react';
import styles from './SaveAsModal.module.css';
import { Modal } from 'react-bootstrap';
import { Select } from '../../Input/Input';

const saveAsOptions = [
  {
    id: 'Draft',
    data: 'Draft',
  },
  {
    id: 'On Hold (Potential Duty)',
    data: 'On Hold (Potential Duty)',
  },
  {
    id: 'Waiting for Customer',
    data: 'Waiting for Customer',
  },
];

const SaveAsModal = ({ show, onHide, onSave, loadId, saveLoadAs, setSaveLoadAs }) => {
  return (
    <Modal contentClassName={styles.modalContent} animation={false} show={show} size="lg" centered onHide={onHide}>
      <Modal.Header>
        <div className="d-flex w-100 justify-content-between">
          <Modal.Title>Save as</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <p>Select the reason you are saving this load</p>

        <Select
          hideLabel={true}
          data={saveLoadAs}
          options={saveAsOptions}
          stopSetDefault={true}
          name="saveAsReason"
          setData={(value) => {
            setSaveLoadAs(value);
          }}
        />
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex w-100 justify-content-between">
          <button className="epo-continue-button small-button" type="button" onClick={onHide}>
            Back
          </button>
          <button
            className="epo-continue-button small-button blue-button-newload"
            style={{ marginTop: 0 }}
            type="button"
            disabled={!saveLoadAs}
            onClick={(event) => {
              if (loadId) {
                onSave(loadId, saveLoadAs); // Saving from CABIE / EPO loads list
              } else {
                onSave(event); // Saving from unified load form
              }
              onHide();
            }}
          >
            Save
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default SaveAsModal;
